import { defineComponent as z, computed as s, openBlock as t, createBlock as i, resolveDynamicComponent as y, normalizeStyle as d, normalizeClass as g } from "vue";
import c from "./index67.js";
import { getIconComponent as k } from "./index282.js";
import { getIconType as C } from "@template/types";
const S = /* @__PURE__ */ z({
  __name: "BaseIcon",
  props: {
    name: {},
    size: { default: "md" },
    color: { default: "currentColor" },
    className: {},
    isLoading: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = a, l = s(() => k(e.name)), m = {
      xs: "icon-xs",
      sm: "icon-sm",
      md: "icon-md",
      lg: "icon-lg",
      xl: "icon-xl"
    }, u = {
      fill: "icon-fill",
      stroke: "icon-stroke"
    }, p = s(() => {
      const o = [
        // 1. 레이아웃
        "inline-block"
      ];
      typeof e.size == "string" && o.push(m[e.size]);
      const n = C(e.name);
      return n && o.push(u[n]), e.className && o.push(e.className), o.join(" ");
    }), f = s(() => {
      const o = {};
      return typeof e.size == "number" && (o.width = `${e.size}px`, o.height = `${e.size}px`), e.color && e.color !== "currentColor" && (o.color = e.color), o;
    }), r = s(() => typeof e.size == "number" ? e.size <= 16 ? "sm" : e.size <= 24 ? "md" : e.size <= 32 ? "lg" : "xl" : e.size);
    return (o, n) => e.isLoading ? (t(), i(c, {
      key: 0,
      size: r.value
    }, null, 8, ["size"])) : l.value ? (t(), i(y(l.value), {
      key: 1,
      class: g(p.value),
      style: d(f.value),
      "aria-hidden": "true"
    }, null, 8, ["class", "style"])) : (t(), i(c, {
      key: 2,
      size: r.value
    }, null, 8, ["size"]));
  }
});
export {
  S as default
};
